/**
 * API base URL for axios calls.
 * In dev with VUE_APP_DEV_PROXY=true, returns '' so requests hit the Vue dev server
 * and are proxied to the backend (avoids CORS).
 */
export function getApiBaseUrl() {
  if (
    process.env.NODE_ENV === 'development' &&
    process.env.VUE_APP_DEV_PROXY === 'true'
  ) {
    return ''
  }

  const host = process.env.VUE_APP_API_URL
  if (!host) {
    return ''
  }

  return `https://${host}`
}
